import React, { Fragment, useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import RecomendationSurveyTable from "./RecomendationSurveyTable";
import AnimationBar from './AnimationBar';

const SatisfactionSurvey = ({ }) => {

    const [surveyData, setSurveyData] = useState([]);
    const [trimester, setTrimester] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

    }, []);

    const handleChangeTrimester = async (value) => {
        setTrimester(value);
        await dataSurvey(value);
    }

    const dataSurvey = async (trimestre) => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'indicadores/encuesta-recomendacion', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                trimestre: trimestre
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            console.log("dataRecomendacion",data);
            setSurveyData(data.indicador);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setSurveyData([]);
            setLoading(false);
        });
    }

    return (
        <Fragment>

            <div>
                <TextField
                    label="Trimestre"
                    value={trimester}
                    onChange={(event) => {
                        handleChangeTrimester(event.target.value);
                    }}
                    select
                    style={{ minWidth: '100%', maxWidth: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }
                    }}
                >
                    <MenuItem key={1} value={1}>
                        Primer Trimestre
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                        Segundo Trimestre
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                        Tercer Trimestre
                    </MenuItem>
                    <MenuItem key={4} value={4}>
                        Cuarto Trimestre
                    </MenuItem>
                </TextField>
            </div>

            <div>
                {
                    loading == false ?
                        <>
                            {
                                surveyData.length > 0 ? <Row>
                                    <Col md={12}>
                                        <RecomendationSurveyTable reactTableData={surveyData} />
                                    </Col>
                                    <Col md={12}>
                                        <AnimationBar dataIndicator={surveyData} />
                                    </Col>
                                </Row> : null
                            }
                        </>
                        :
                        <div className="text-center">
                            <Spinner animation="border" variant="success" />
                        </div>
                }
            </div>

        </Fragment>
    );
}
export default SatisfactionSurvey;